module.exports = __webpack_public_path__ + "img/box-packaging-0@2x.60f89551.png";